// You can specify which plugins you need

import "./modules/webfont";
import "./modules/menu-trigger";
import "./modules/loader";
import "./modules/button-common-hover";
import "./modules/section-introduction";
import "./modules/section-service";
import "./modules/section-works";
import "./modules/swiper";
import "./modules/button-down";
